"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformacionEmprendimiento = void 0;
var React = require("react");
var required_select_js_1 = require("../utils/required_select.js");
var Clases = require("../../clases_comunes");
var OpcionesList = require("../../opciones.js");
var TrianguloAquamarine = require("../../assets/img/AquamarinePng.png");
var InformacionEmprendimiento = /** @class */ (function (_super) {
    __extends(InformacionEmprendimiento, _super);
    function InformacionEmprendimiento(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            infolaboral: new Clases.InfoLaboral(),
        };
        // METODOS
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        _this.validarAvanceSiguiente = _this.validarAvanceSiguiente.bind(_this);
        return _this;
    }
    InformacionEmprendimiento.prototype.componentDidMount = function () {
        this.setState({ infolaboral: this.props.infolaboral });
    };
    InformacionEmprendimiento.prototype.handleChange = function (event) {
        if (event.target.name.startsWith("inflab")) {
            var tnameil = event.target.name.split("-");
            var dtolaboral = this.state.infolaboral;
            if (tnameil[1] === "salariomensual") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 9);
            }
            else if (tnameil[1] === "motivotrabajonr ") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 999);
            }
            else if (tnameil[1] === "nombrejefeinmediato ") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 99);
            }
            else if (tnameil[1] === "cargojefeinmediato ") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 99);
            }
            else if (tnameil[1] === "emailjefeinmediato") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 99);
            }
            else if (tnameil[1] === "motivoestudiar") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 999);
            }
            else if (tnameil[1] === "otraareadesempeno") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 74);
            }
            else {
                dtolaboral[tnameil[1]] = event.target.value;
            }
            this.setState({ infolaboral: dtolaboral });
            this.showNewQuestions(event.target.name, event.target.value);
        }
    };
    InformacionEmprendimiento.prototype.handleSelectChange = function (selectedOption, selName) {
        var _this = this;
        if (selectedOption != null) {
            if (selName.name.startsWith("inflab")) {
                var tnameils = selName.name.split("-");
                var dtolaboral = this.state.infolaboral;
                dtolaboral[tnameils[1]] = selectedOption.value;
                this.setState({ infolaboral: dtolaboral }, function () {
                    _this.showNewQuestions(selName.name, selectedOption.value);
                });
            }
        }
    };
    InformacionEmprendimiento.prototype.showNewQuestions = function (name, answer) {
        if (name.startsWith("inflab")) {
            var tnamels = name.split("-");
            var dtoinfolabshow = this.state.infolaboral;
            if (tnamels[1] === "situacionlaboral") {
                if (answer === "ND") {
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["relacioncarrera"] = "";
                    dtoinfolabshow["motivotrabajonr"] = "";
                    dtoinfolabshow["nombreempresa"] = "";
                    dtoinfolabshow["emailempresa"] = "";
                    dtoinfolabshow["idpais"] = 0;
                    dtoinfolabshow["sectorempresa"] = 0;
                    dtoinfolabshow["cargoempresa"] = "";
                    dtoinfolabshow["niveldocencia"] = "";
                    dtoinfolabshow["cantpersonascargo"] = 0;
                    dtoinfolabshow["aniosexperiencia"] = 0;
                    dtoinfolabshow["salariomensual"] = 0;
                    dtoinfolabshow["idiomatrabajo"] = "";
                    dtoinfolabshow["tipocomunicacion"] = "";
                    dtoinfolabshow["tiempoprimertrabajo"] = "";
                    dtoinfolabshow["primertrabajo"] = "";
                    dtoinfolabshow["tamanioempresa"] = "";
                    dtoinfolabshow["cargojefeinmediato"] = "";
                    dtoinfolabshow["nombrejefeinmediato"] = "";
                    dtoinfolabshow["emailjefeinmediato"] = "";
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                    dtoinfolabshow["nombreempresafactura"] = "";
                    dtoinfolabshow["modalidadtrabajo"] = "";
                    dtoinfolabshow["areadesempeno"] = "";
                    dtoinfolabshow["horassemanales"] = 0;
                }
                else if (answer === "BPT" || answer === "SE") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["relacioncarrera"] = "";
                    dtoinfolabshow["motivotrabajonr"] = "";
                    dtoinfolabshow["nombreempresa"] = "";
                    dtoinfolabshow["emailempresa"] = "";
                    dtoinfolabshow["idpais"] = 0;
                    dtoinfolabshow["sectorempresa"] = 0;
                    dtoinfolabshow["cargoempresa"] = "";
                    dtoinfolabshow["niveldocencia"] = "";
                    dtoinfolabshow["cantpersonascargo"] = 0;
                    dtoinfolabshow["aniosexperiencia"] = 0;
                    dtoinfolabshow["salariomensual"] = 0;
                    dtoinfolabshow["idiomatrabajo"] = "";
                    dtoinfolabshow["tipocomunicacion"] = "";
                    dtoinfolabshow["tiempoprimertrabajo"] = "";
                    dtoinfolabshow["primertrabajo"] = "";
                    dtoinfolabshow["tamanioempresa"] = "";
                    dtoinfolabshow["cargojefeinmediato"] = "";
                    dtoinfolabshow["nombrejefeinmediato"] = "";
                    dtoinfolabshow["emailjefeinmediato"] = "";
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                    dtoinfolabshow["modalidadtrabajo"] = "";
                    dtoinfolabshow["areadesempeno"] = "";
                    dtoinfolabshow["horassemanales"] = 0;
                    if (answer === "PN") {
                        dtoinfolabshow["negociopropio"] = "S";
                    }
                }
                else if (answer === "PN") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["relacioncarrera"] = "";
                    dtoinfolabshow["motivotrabajonr"] = "";
                    dtoinfolabshow["nombreempresa"] = "";
                    dtoinfolabshow["emailempresa"] = "";
                    dtoinfolabshow["idpais"] = 0;
                    dtoinfolabshow["sectorempresa"] = 0;
                    dtoinfolabshow["cargoempresa"] = "";
                    dtoinfolabshow["niveldocencia"] = "";
                    dtoinfolabshow["cantpersonascargo"] = 0;
                    dtoinfolabshow["aniosexperiencia"] = 0;
                    dtoinfolabshow["salariomensual"] = 0;
                    dtoinfolabshow["idiomatrabajo"] = "";
                    dtoinfolabshow["tipocomunicacion"] = "";
                    dtoinfolabshow["tiempoprimertrabajo"] = "";
                    dtoinfolabshow["primertrabajo"] = "";
                    dtoinfolabshow["tamanioempresa"] = "";
                    dtoinfolabshow["cargojefeinmediato"] = "";
                    dtoinfolabshow["nombrejefeinmediato"] = "";
                    dtoinfolabshow["emailjefeinmediato"] = "";
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                    dtoinfolabshow["modalidadtrabajo"] = "";
                    dtoinfolabshow["areadesempeno"] = "";
                    dtoinfolabshow["horassemanales"] = 0;
                    dtoinfolabshow["nombreempresafactura"] = "";
                    dtoinfolabshow["negociopropio"] = "S";
                }
                else if (answer === "TRD") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["nombreempresafactura"] = "";
                }
                else if (answer === "PEI") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionreldepen"] = "";
                }
                else if (answer === "RDN") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["negociopropio"] = "S";
                }
            }
            else if (tnamels[1] === "motivond") {
            }
            else if (tnamels[1] === "relacioncarrera") {
                if (answer === "NR") {
                }
                else if (answer !== "" && answer !== null && answer !== "NR") {
                    dtoinfolabshow["motivotrabajonr"] = "";
                }
            }
            else if (tnamels[1] === "cargoempresa") {
                if (answer === "DO") {
                }
                else if (answer !== "" && answer !== null && answer !== "DO") {
                    dtoinfolabshow["niveldocencia"] = "";
                }
            }
            else if (tnamels[1] === "idiomatrabajo") {
                if (answer === "N" || answer === "" || answer === null) {
                    dtoinfolabshow["tipocomunicacion"] = "";
                }
                else if (answer !== "" && answer !== null && answer !== "N") {
                    //(document.getElementById("tipocomunpregunta") as HTMLInputElement).style.removeProperty("display");
                }
            }
            else if (tnamels[1] === "negociopropio") {
                if (answer === "N") {
                    dtoinfolabshow["dedicacionnp"] = "";
                    dtoinfolabshow["aniosnp"] = 0;
                    dtoinfolabshow["relacionnpcarrera"] = "";
                    dtoinfolabshow["sectornp"] = 0;
                    dtoinfolabshow["nombrenp"] = "NA";
                    dtoinfolabshow["productonp"] = "";
                }
            }
            else if (tnamels[1] === "idpais") {
                if (answer === 1) {
                    //(document.getElementById("localidad-empresa") as HTMLInputElement).style.removeProperty("display");
                }
                else if (answer !== 0 && answer !== null && answer !== 1) {
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                }
            }
            else if (tnamels[1] === "areadesempeno") {
                if (answer !== "O") {
                    dtoinfolabshow["otraareadesempeno"] = "";
                }
            }
            this.setState({ infolaboral: dtoinfolabshow });
        }
    };
    InformacionEmprendimiento.prototype.validarAvanceSiguiente = function (event) {
        event.preventDefault();
        this.props.validarCambiosSeccion(event, this.state.infolaboral);
    };
    InformacionEmprendimiento.prototype.render = function () {
        return (React.createElement("form", { id: "alumniform-emprendimiento", name: "alumniform-emprendimiento", onSubmit: this.validarAvanceSiguiente },
            React.createElement("div", { className: "aquamarine-border", style: { paddingLeft: "20px", paddingRight: "20px" } },
                React.createElement("div", { id: "informacion-emprendimiento" },
                    React.createElement("div", { className: "form-group row section-title" },
                        React.createElement("div", { style: { backgroundColor: "white" } },
                            React.createElement("img", { src: TrianguloAquamarine, alt: "", className: "small-icon", style: { width: "50px", height: "50px" } }),
                            React.createElement("h5", { className: "down aquamarine-text small-h5title" }, "EMPRENDIMIENTO"))),
                    React.createElement("br", null),
                    React.createElement("div", { className: "form-group row", id: "pregunta14inflab" },
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingRight: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "negpropio" },
                                "\u00BFHa emprendido un negocio propio? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(required_select_js_1.default, { options: OpcionesList.YesNoList, name: "inflab-negociopropio", id: "negpropio", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infolaboral.negociopropio ? this.state.infolaboral.negociopropio : '', isDisabled: this.state.infolaboral.situacionlaboral === "PN" || this.state.infolaboral.situacionlaboral === "RDN", required: true, isMulti: false })),
                        this.state.infolaboral.negociopropio === "S" && (React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "dedicacionnp" },
                                "\u00BFCu\u00E1l es su dedicaci\u00F3n al negocio propio? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(required_select_js_1.default, { options: OpcionesList.DedicacionejerindepList, name: "inflab-dedicacionnp", id: "dedicacionnp", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infolaboral.dedicacionnp ? this.state.infolaboral.dedicacionnp : '', isDisabled: false, required: this.state.infolaboral.negociopropio === "S", isMulti: false })))),
                    this.state.infolaboral.negociopropio === "S" && (React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingRight: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "productonp" },
                                "\u00BFQu\u00E9 producto o servicio ofrece? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.infolaboral.productonp, name: "inflab-productonp", id: "productonp", onChange: this.handleChange, required: this.state.infolaboral.negociopropio === "S", maxLength: 99 })),
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "aniosnp" },
                                "\u00BFCu\u00E1ntos a\u00F1os tiene en funcionamiento su negocio propio? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("input", { className: "form-control form-control-sm", type: "number", value: this.state.infolaboral.aniosnp > 0 ? this.state.infolaboral.aniosnp : '', name: "inflab-aniosnp", id: "aniosnp", onChange: this.handleChange, onKeyDown: this.props.exceptionsInput, required: this.state.infolaboral.negociopropio === "S" })))),
                    this.state.infolaboral.negociopropio === "S" && (React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingRight: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "relcarnegpro" },
                                "\u00BFQu\u00E9 tan relacionado est\u00E1 el giro de su negocio con su ",
                                this.props.graduadoPost ? "PROGRAMA de posgrado" : "CARRERA de grado",
                                " en la ESPOL? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(required_select_js_1.default, { options: OpcionesList.RelacionCarreraList, name: "inflab-relacionnpcarrera", id: "relcarnegpro", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infolaboral.relacionnpcarrera ? this.state.infolaboral.relacionnpcarrera : '', isDisabled: false, required: this.state.infolaboral.negociopropio === "S", isMulti: false })),
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "sectornp", style: { marginTop: "22px" } },
                                "\u00BFA qu\u00E9 sector pertenece su emprendimiento? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(required_select_js_1.default, { options: this.props.sectorList, name: "inflab-sectornp", id: "sectornp", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infolaboral.sectornp ? this.state.infolaboral.sectornp : '', isDisabled: false, required: this.state.infolaboral.negociopropio === "S", isMulti: false })))),
                    React.createElement("br", null),
                    React.createElement("div", null,
                        React.createElement("label", { style: { fontSize: "large" } },
                            "(",
                            React.createElement("span", { className: "required-field" }, "*"),
                            ") Campos requeridos")))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("div", { className: "form-group row", id: "siguiente-emprendimiento", style: { float: "right" } },
                React.createElement("button", { type: "button", name: "prev-emprend-button", id: "prev-emprend-button", className: "btn btn-info buttonSpace", onClick: this.props.retrocederSeccion }, "Anterior"),
                React.createElement("button", { type: "submit", className: "btn btn-info buttonSpace" }, "Siguiente"))));
    };
    return InformacionEmprendimiento;
}(React.Component));
exports.InformacionEmprendimiento = InformacionEmprendimiento;
//# sourceMappingURL=InformacionEmprendimiento.js.map